/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.22",
    versionName: "0.2.0-nightly.2026.3.22",
    versionChannel: "nightly",
    buildDate: "2026-03-22T00:10:39.813Z",
    commitHash: "a845a22d04bddb2aa1572458f31a855b5a17430d",
};
